import { createAction, props } from '@ngrx/store';

export const loadPaymentTerms = createAction('[Payment Terms] Load');

export const loadPaymentTermsSuccess = createAction('[Payment Terms] Load Success', props<{ response: any[] }>());

export const loadPaymentTermsSuccessByKey = createAction(
  '[Payment Terms] Load Success By Key',
  props<{ key: string; response: any[] }>(),
);

export const loadPaymentTermsFailure = createAction('[Payment Terms] Load Failure', props<{ error: any }>());
